import React from 'react';
import cn from 'classnames';

import { programStatusOptions } from 'Models/Enums';

import Chip from 'Views/Components/Chip/Chip';
import { ValueOf } from 'Util/TypeHelpers';

export interface IChipStatusProps {
	status: ValueOf<typeof programStatusOptions>;
	onClick?: () => void;
	className?: string;
}

// Maps program status option values to class names
const statusClassMap: Record<IChipStatusProps['status'], string> = {
	[programStatusOptions.DRAFT]: 'draft',
	[programStatusOptions.IN_REVIEW]: 'in-review',
	[programStatusOptions.PUBLISHED]: 'published',
	[programStatusOptions.ARCHIVED]: 'archived',
	[programStatusOptions.APPROVED]: 'approved',
};

const StatusChip = ({ status, onClick, className }: IChipStatusProps) => {
	if (!status) {
		return null;
	}
	const statusClass = statusClassMap[status];
	return (
		<Chip
			chipLabel={status?.toLocaleLowerCase()}
			onClick={onClick}
			className={cn('program-version-status-chip', statusClass, className)}
		/>
	);
};

export default StatusChip;
